import React from 'react';
import { useViewport } from '../../../design-system/hooks/useViewport';
import GooglePlacesAutocomplete from './GooglePlacesAutocomplete';

/**
 * The address autocomplete, wearing the design system's input.
 *
 * `GooglePlacesAutocomplete` is a shared control that four converted forms use
 * (edit profile, edit delivery, saved addresses, seller registration) and that
 * unconverted routes still use too, so it cannot change its own class names
 * yet. What it DOES accept is a `className` on the input it renders, and that
 * is the whole job here: hand it the track's input class so the field inside a
 * converted form matches every other field beside it.
 *
 * The wrapper `div.google-places-autocomplete` it draws around the input is
 * layout only (`display: block`), so it is inert here. It goes when the last
 * unconverted caller does.
 *
 * `error` maps to the track's error modifier rather than to a local red, so an
 * invalid address field looks exactly like an invalid text field.
 */
export default function PlacesInput({ error = false, className, ...rest }) {
  const { isDesktop } = useViewport();
  const base = isDesktop ? 'dsk-input' : 'ds-input';
  const invalid = error ? (isDesktop ? 'dsk-input--error' : 'ds-input--error') : '';

  return (
    <GooglePlacesAutocomplete
      className={[base, invalid, className].filter(Boolean).join(' ')}
      aria-invalid={error ? true : undefined}
      {...rest}
    />
  );
}
